import { createStore } from 'vuex';
import inclusaoStore from './inclusao';
import tarefaStore from './tarefas';
import tarefaPlanilhaStore from './tarefasPlanilha';
import pesaveisStore from './pesaveis';
import rebaixasStore from './rebaixas';

const store = createStore({
    modules: {
        inclusao: inclusaoStore,
        tarefas: tarefaStore,
        tarefasPlanilha: tarefaPlanilhaStore,
        pesaveis: pesaveisStore,
        rebaixas: rebaixasStore,
    },
    state() {
        return {
            todosProdutos: null,
            codigoInclusao: null,
            numeroSync: 0,
            lojaUsuario: null,
            header: null,
        };
    },
    mutations: {
        setTodosProdutos(state, payload) {
            state.todosProdutos = payload;
        },
        setCodigoInclusao(state, payload) {
            state.codigoInclusao = payload;
        },
        plusNumeroSync(state) {
            state.numeroSync++;
        },
        minusNumeroSync(state) {
            state.numeroSync--;
        },
        resetNumeroSync(state) {
            state.numeroSync = 0;
        },
        setLojaUsuario(state, payload) {
            state.lojaUsuario = payload;
        },
        setHeader(state, payload) {
            state.header = payload;
        },
    },
    actions: {
        setTodosProdutos(context, payload) {
            context.commit('setTodosProdutos', payload);
        },
        setCodigoInclusao(context, payload) {
            context.commit('setCodigoInclusao', payload);
        },
        plusNumeroSync(context) {
            context.commit('plusNumeroSync');
        },
        minusNumeroSync(context) {
            context.commit('minusNumeroSync');
        },
        resetNumeroSync(context) {
            context.commit('resetNumeroSync');
        },
        setLojaUsuario(context, payload) {
            context.commit('setLojaUsuario', payload);
        },
        setHeader(context, payload) {
            context.commit('setHeader', payload);
        },
    },
    getters: {
        getTodosProdutos(state) {
            return state.todosProdutos;
        },
        getNumerosSync(state) {
            return state.numeroSync;
        },
        getCodigoInclusao(state) {
            return state.codigoInclusao;
        },
        getLojaUsuario(state) {
            return state.lojaUsuario;
        },
        getHeader(state) {
            return state.header;
        },
    },
});

export default store;
